import { CardProps, Card as _Card } from 'antd';
import { useMemo } from 'react';

import { $Color, Color } from '@suntex.core/color';

import { getClassName } from '../_utils';

const LUMINANCE_THRESHOLD = 0.5;
const BACKGROUND_ALPHA = 0.05;

type Props = Pick<CardProps, 'children' | 'title' | 'className' | 'size'> & {
  color?: Color;
};

export function Card({ className, color, ...props }: Props) {
  const styles = useMemo(() => {
    return color
      ? {
          header: {
            color:
              $Color.getLuminance(color) > LUMINANCE_THRESHOLD
                ? '#000'
                : '#FFF',
            background: $Color.toRGB(color),
            fontWeight: 600,
          },
          body: {
            background: $Color.toRGBA(color, BACKGROUND_ALPHA),
          },
        }
      : undefined;
  }, [color]);
  return (
    <_Card
      {...props}
      className={getClassName('card', className)}
      styles={styles}
    />
  );
}
